import { MoreVert } from '@mui/icons-material'
import { IconButton, Menu, MenuItem } from '@mui/material'
import { useId, useState, type FC } from 'react'

type Props = {
  onReexport: () => void
}

/** 出力一覧の各行の操作メニュー(3点リーダー)。 */
export const ReportExportRowMenu: FC<Props> = ({ onReexport }) => {
  const menuId = useId()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const open = Boolean(anchorEl)

  return (
    <>
      <IconButton
        size="small"
        aria-label="操作メニュー"
        aria-controls={open ? menuId : undefined}
        aria-haspopup="true"
        aria-expanded={open || undefined}
        onClick={e => setAnchorEl(e.currentTarget)}
      >
        <MoreVert />
      </IconButton>
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          onClick={() => {
            setAnchorEl(null)
            onReexport()
          }}
        >
          同じ条件で再出力
        </MenuItem>
      </Menu>
    </>
  )
}
